"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = require("react");
var _utils = require("../utils");
var _index = require("../views/index");
var _createCalendarStateReducer = require("./createCalendarStateReducer");
var _jsxRuntime = require("react/jsx-runtime");
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var DateSelection = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var value = _ref.value,
    onChange = _ref.onChange,
    showDaysOutsideCurrentMonth = _ref.showDaysOutsideCurrentMonth,
    renderDay = _ref.renderDay,
    minDateProp = _ref.minDate,
    maxDateProp = _ref.maxDate,
    disablePast = _ref.disablePast,
    disableFuture = _ref.disableFuture,
    _ref$view = _ref.view,
    view = _ref$view === void 0 ? 'date' : _ref$view,
    shouldDisableDate = _ref.shouldDisableDate,
    withTodayButton = _ref.withTodayButton;
  var viewHelpers = (0, _utils.useViewHelpers)(view);
  var minDate = viewHelpers.startOfItem(minDateProp);
  var maxDate = viewHelpers.startOfItem(maxDateProp);
  var correctedValue = (0, _react.useMemo)(function () {
    return value || (0, _utils.getEmpty)(minDate, maxDate);
  }, [value, minDate, maxDate]);
  var _useReducer = (0, _react.useReducer)((0, _createCalendarStateReducer.createCalendarStateReducer)(viewHelpers), {
      date: viewHelpers.startOfView(correctedValue),
      focusedDate: viewHelpers.startOfItem(correctedValue)
    }),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    _useReducer2$ = _useReducer2[0],
    date = _useReducer2$.date,
    focusedDate = _useReducer2$.focusedDate,
    dispatch = _useReducer2[1];
  var handleCurrentDateChange = function handleCurrentDateChange(date) {
    dispatch({
      type: _createCalendarStateReducer.CHANGE_CURRENT_DATE,
      payload: {
        newDate: date
      }
    });
  };
  var handleIsDateSelected = (0, _react.useCallback)(function (day) {
    return viewHelpers.isSameItem(day, value);
  }, [value]);
  var handleDateSelect = function handleDateSelect(date) {
    onChange(date, true);
  };
  var isDateEnable = (0, _utils.useIsDateEnable)({
    minDate: minDate,
    maxDate: maxDate,
    disablePast: disablePast,
    disableFuture: disableFuture
  });
  var handleIsDateDisabled = (0, _react.useCallback)(function (day) {
    return isDateEnable(day) || Boolean(shouldDisableDate && shouldDisableDate(day));
  }, [shouldDisableDate, isDateEnable]);
  var handleFocusedDateChange = function handleFocusedDateChange(date) {
    dispatch({
      type: _createCalendarStateReducer.CHANGE_FOCUSED_DATE,
      payload: {
        newFocusedDate: date
      }
    });
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_index.ViewSwitcher, {
    view: view,
    minDate: minDate,
    maxDate: maxDate,
    disablePast: disablePast,
    disableFuture: disableFuture,
    current: date,
    focusedDate: focusedDate,
    onDateSelect: handleDateSelect,
    onDateFocus: handleFocusedDateChange,
    onCurrentChange: handleCurrentDateChange,
    isDateSelected: handleIsDateSelected,
    isDateDisabled: handleIsDateDisabled,
    showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth,
    renderDay: renderDay,
    withTodayButton: withTodayButton,
    ref: ref
  });
});
var _default = exports["default"] = DateSelection;